import { BASE_ENDPOINT } from "../../../endpoint";

export const updateCustomerService = async (token: string, customerId: string, payload: any) => {
    try {
        const response = await fetch(`${BASE_ENDPOINT}/user/customerservice/customer/${customerId}`, {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            body: payload
        });
        const res = await response.json();
        if (!response.ok) {
            console.error('Error:', res);
            throw new Error(res.message);
        }
        return res;
    } catch (error) {
        console.error('API fetch error:', error);
        throw error;
    }
};
